import Swiper from 'swiper';
import 'swiper/swiper-bundle.css';
import './index.css';

export default {
  name: 'Aswiper',
  props: {
    id: { type: String, default: () => (`a-swiper-${Math.random().toString().substring(2)}`) },
    config: { type: Object, default: () => ({}) },
    data: {
      type: Array,
      default: () => [
        { title: 'item1', image: null, color: '#409EFF' },
        { title: 'item2', image: null, color: '#67C23A' },
        { title: 'item3', image: null, color: '#E6A23C' },
        { title: 'item4', image: null, color: '#F56C6C' },
      ]
    },
    items: { type: Array, default: () => null },
    config: { type: Array, default: () => null },
    option: { type: Array, default: () => null },
    options: { type: Array, default: () => null },
  },
  data() {
    return {
      swiper: null,
    }
  },
  mounted() {
    this.create();
  },
  destroyed() {
    this.revoke();
  },
  methods: {
    create() {
      const config = {
        loop: true,
        autoplay: {
          delay: 3000,
          stopOnLastSlide: false,
          disableOnInteraction: true,
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        ...this.config,
        ...this.$attrs
      };
      this.swiper = new Swiper(`#${this.id}`, config);
    },
    revoke() {
      this.swiper = null;
    }
  },
  render() {
    const data = this.options || this.option || this.config || this.items || this.data || [];
    return data.length > 0 && (
      <div id={this.id} class="swiper-container a-swiper">
        <div class="swiper-wrapper a-swiper-wrapper">
          {data.map((a, b) => {
            const title = a.title || a.label || a.text || a.name;
            const image = a.backgroundImage || a.background || a.images || a.image || a.color || a.rgba || a.rgb;
            return (
              <div key={b} class="swiper-slide a-swiper-slide" style={{ background: image }}>
                {a.render ? a.render() : title}
              </div>
            );
          })}
        </div>
        <div class="swiper-button-next a-swiper-button-next" />
        <div class="swiper-button-prev a-swiper-button-prev" />
        <div class="swiper-pagination a-swiper-pagination" />
      </div>
    );
  }
}